import { resolveMediaUrl } from "./mediaUrl";
import { isWikipediaMediaUrl } from "./ownMaterial";
import { SIXAMICO_MEDIA } from "../data/sixamicoMedia";
import {
  HERO_BY_SLUG,
  HERO_FALLBACK_IMG,
  MOSCIANO_SANT_ANGELO_IMG,
  CROGNALETO_IMG,
  hasNoCertifiedPhoto,
  heroForSlug,
  isDeadMediaUrl,
} from "./heroImages";
import { CROGNALETO_SLUG, CROGNALETO_TERRITORY_HERO, isNeritoMunicipioMediaUrl } from "./crognaletoMedia";

// Region → Pexels fallback (pool 6amico). Admin upload resta prioritario.

import { ABRUZZO_GENERIC_IMG } from "./heroImages";

const REGION_HERO = {
  Abruzzo: ABRUZZO_GENERIC_IMG,
  Basilicata: SIXAMICO_MEDIA.regionBasilicata,
  Calabria: SIXAMICO_MEDIA.regionCalabria,
  Campania: SIXAMICO_MEDIA.regionCampania,
  "Emilia-Romagna": SIXAMICO_MEDIA.regionEmilia,
  "Friuli-Venezia Giulia": SIXAMICO_MEDIA.regionFriuli,
  Lazio: SIXAMICO_MEDIA.regionLazio,
  Liguria: SIXAMICO_MEDIA.regionLiguria,
  Lombardia: SIXAMICO_MEDIA.regionLombardia,
  Marche: SIXAMICO_MEDIA.regionMarche,
  Molise: SIXAMICO_MEDIA.regionMolise,
  Piemonte: SIXAMICO_MEDIA.regionPiemonte,
  Puglia: SIXAMICO_MEDIA.regionPuglia,
  Sardegna: SIXAMICO_MEDIA.regionSardegna,
  Sicilia: SIXAMICO_MEDIA.regionSicilia,
  Toscana: SIXAMICO_MEDIA.regionToscana,
  "Trentino-Alto Adige": SIXAMICO_MEDIA.regionTrentino,
  "Trentino-Alto Adige/Südtirol": SIXAMICO_MEDIA.regionTrentino,
  Umbria: SIXAMICO_MEDIA.regionUmbria,
  "Valle d'Aosta": SIXAMICO_MEDIA.regionValleAosta,
  "Valle d'Aosta/Vallée d'Aoste": SIXAMICO_MEDIA.regionValleAosta,
  Veneto: SIXAMICO_MEDIA.regionVeneto,
};

const DEFAULT_HERO = HERO_FALLBACK_IMG;

function pickLiveUrl(url) {
  const u = resolveMediaUrl(url);
  if (!u) return null;
  if (isWikipediaMediaUrl(u)) return null;
  if (isDeadMediaUrl(u)) return null;
  if (String(u).includes("/api/uploads/admin/")) return u;
  if (String(u).includes("/api/uploads/")) return u;
  if (String(u).includes("/wp-content/uploads/")) return u;
  if (String(u).includes("/hero/") || String(u).includes("/images/") || String(u).includes("/img/")) {
    return u;
  }
  if (String(u).includes("upload.wikimedia.org") || String(u).includes("commons.wikimedia.org")) {
    return u;
  }
  if (!u.startsWith("http")) return null;
  return u;
}

function firstGalleryUpload(c) {
  if (!c || !Array.isArray(c.gallery)) return null;
  const slug = typeof c.slug === "string" ? c.slug.trim().toLowerCase() : "";
  for (const g of c.gallery) {
    const u = pickLiveUrl(g);
    if (u && u.includes("/api/uploads/")) return u;
  }
  return null;
}

export function comuneHero(c) {
  if (!c) return DEFAULT_HERO;
  const slug = typeof c.slug === "string" ? c.slug.trim().toLowerCase() : "";
  const noCertifiedPhoto = hasNoCertifiedPhoto(slug);

  const uploadImg =
    pickLiveUrl(c.image) ||
    pickLiveUrl(c.hero_image) ||
    pickLiveUrl(c.hero_image_url);
  if (uploadImg && uploadImg.includes("/api/uploads/") && !isNeritoMunicipioMediaUrl(uploadImg)) return uploadImg;
  if (uploadImg && uploadImg.includes("/wp-content/uploads/")) return uploadImg;

  if (slug === "mosciano-sant-angelo") {
    if (uploadImg && uploadImg.includes("borgo-cacchi")) return uploadImg;
    return MOSCIANO_SANT_ANGELO_IMG;
  }
  if (slug === CROGNALETO_SLUG) {
    if (uploadImg && !isNeritoMunicipioMediaUrl(uploadImg)) return uploadImg;
    return resolveMediaUrl(CROGNALETO_TERRITORY_HERO) || CROGNALETO_IMG;
  }
  if (uploadImg && !isDeadMediaUrl(uploadImg)) return uploadImg;

  const fromGallery = firstGalleryUpload(c);
  if (fromGallery) return fromGallery;

  if (noCertifiedPhoto) {
    const candidates = [c.image, c.hero_image, c.hero_image_url, ...(Array.isArray(c.gallery) ? c.gallery : [])];
    for (const candidate of candidates) {
      const u = pickLiveUrl(candidate);
      if (u && u.includes("/api/uploads/")) return u;
    }
    return "";
  }
  if (slug && HERO_BY_SLUG[slug]) {
    return HERO_BY_SLUG[slug];
  }
  return heroForSlug(slug || c.slug, c.region) || DEFAULT_HERO;
}

/** URL statico editoriale (asset 6amico) se l'API non ha ancora l'immagine regione. */
export function regionHero(region) {
  const key = region && REGION_HERO[region];
  if (key && !isDeadMediaUrl(key)) return key;
  return SIXAMICO_MEDIA.comuni || SIXAMICO_MEDIA.natura || DEFAULT_HERO;
}

export { REGION_HERO, DEFAULT_HERO };
